import { useCallback, useState } from "react";
import { tomatoThrowDisplayScale } from "../reactionThrowAssets";
import { LottieSplatPlayer } from "./LottieSplatPlayer";

const TOMATO_PLAYS = 3;

type Props = {
  /** Resolved URL from `pickStableTomatoThrowSrc` (any `public/lottie/tomato/*.json`). */
  src: string;
  onComplete: () => void;
  className?: string;
};

/** Tomato reaction: play the chosen tomato Lottie three times in a row (mirror L/R/L), no wet-paint splat. */
export function TomatoTripleThrowLottie({ src, onComplete, className }: Props) {
  const [playIndex, setPlayIndex] = useState(0);
  const displayScale = tomatoThrowDisplayScale(src);

  const onOnePlayComplete = useCallback(() => {
    if (playIndex < TOMATO_PLAYS - 1) {
      setPlayIndex((n) => n + 1);
    } else {
      onComplete();
    }
  }, [playIndex, onComplete]);

  /** Alternate horizontal direction: left → right → left across the three plays. */
  const mirror = playIndex % 2 === 1;
  const transformParts: string[] = [];
  if (displayScale !== 1) transformParts.push(`scale(${displayScale})`);
  if (mirror) transformParts.push("scaleX(-1)");
  const transform = transformParts.length ? transformParts.join(" ") : undefined;

  return (
    <div className="reaction-splat-pop-inner reaction-scene-reveal">
      <div
        style={{
          width: "100%",
          height: "100%",
          transform,
          transformOrigin: "center center",
        }}
      >
        <LottieSplatPlayer
          key={`${playIndex}-${src}`}
          src={src}
          onComplete={onOnePlayComplete}
          className={className}
        />
      </div>
    </div>
  );
}
